import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
const Portal = (props) => {
    const { children, container } = props;
    const mountNode = container || document.body;
    return ReactDOM.createPortal(children, mountNode);
};
Portal.propTypes = {
    children: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    container: PropTypes.any
};
Portal.defaultProps = {
    container: null
};
export default Portal;
//# sourceMappingURL=Portal.js.map